import { RootState } from "../store/reducers";
import { useSelector } from "react-redux";

export const useBetaUser = (): boolean => {
  const isBetaUser = useSelector<RootState, boolean>(
    ({ auth }) => auth.isBetaUser
  );
  return isBetaUser;
};
